exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/admin/user/list-user/list-user.component.scss
// module id = ../../../../../src/app/admin/user/list-user/list-user.component.scss
// module chunks = main